import { Component, Directive, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'perfect-scrollbar',
  template: `<ng-content />`,
  standalone: false,
})
export class PerfectScrollbarComponent {}

@Directive({
  selector: '[perfectScrollbar]',
  standalone: false,
})
export class PerfectScrollbarDirective {
  @Input() perfectScrollbar: unknown;
  @HostBinding('class')
  elementClass = 'perfect-scrollbar';
}
